/*eslint-env jquery*/
import React, { Component } from 'react'
import { toastr } from 'react-redux-toastr'
import Loading from '../Shared/Loading'
import { Tabs, Tab } from 'react-bootstrap'
import { history } from '../../_helpers'
import { usersService } from '../../_services/users.service'
import UserMessages from '../Messages/UserMessages'

import { Formik, FieldArray, Field } from 'formik'
import * as Yup from 'yup'

import Step1 from './Step1'

import { AiOutlineLoading, AiOutlineSave } from "react-icons/ai";

class Form extends Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      loading: false,
      key: 'info',
      id: this.props.match.params.id,
      isReseller: false,
      data: {
        id: undefined,
        changePass: true,
        gender: '',
        firstName: '',
        lastName: '',
        mobile: '',
        userType: '',
        email: '',
        password: '',
        confirmPassword: '',
        provinces: [],
      }
    }


  }

  componentDidMount() {
    this.getData()
  }

  getData = async () => {

    const { id } = this.state;

    if (id) {

      this.setState({ loading: true });

      await usersService.getById(id)
        .then((res) => {

          let data = res.data;
          // if (data.userType === 2) {
          //   data["isReseller"] = true;
          // }
          console.log(data);

          this.setState({ data: data, loading: false })

        })
        .catch((error) => {

          console.log(error);

          this.setState({ loading: false });

        });

    }


  };

  handleSubmit = (values, setSubmitting) => {
    // this.setState({ loading: true });

    if (values.id) {

    console.log(JSON.stringify(values));
      usersService.edit(values.id, JSON.stringify(values))
        .then((res) => {

          console.log(res.data);
          toastr.success('ویرایش کاربر', 'کاربر "' + values.firstName + ' ' + values.lastName + '" با موفقیت ویرایش شد');
          history.push("/admin/users")
          setSubmitting(false);

        })
        .catch((error) => {
          console.log(error);
          setSubmitting(false);
        });

    } else {

      // console.log(JSON.stringify(values));
      usersService.add(JSON.stringify(values))
        .then((res) => {
          // console.log(res);

          this.setState({ loading: false, data: res.data });
          toastr.success('ثبت کاربر جدید', 'کاربر جدید  "' + values.firstName + ' ' + values.lastName + '" با موفقیت ثبت شد');
          history.push("/admin/users")
          setSubmitting(false);


        })
        .catch((error) => {
          setSubmitting(false);

          toastr.error('ثبت کاربر جدید', 'ایمیل یا موبایل وارد شده تکراری است');
        });

    }
  }

  handleError(error) {
    this.setState({ loading: false });
    // toastr.warning('مشکلی پیش آمد', error);
  }

  validateForm = (errors) => {
    if (Object.keys(errors).length > 0) {
      // // console.log(errors)
      let obj = errors
      let { createdDate, workStartDate, firstName, lastName, codeMeli, idnumber, birthDate, cellNumber, address, travelBrandId, gender, degree, childrenCount,
        driverDocuments,
        user
      } = obj;
      if (createdDate || workStartDate || firstName || lastName || codeMeli || idnumber || birthDate || cellNumber || address || travelBrandId || gender || degree || childrenCount) {
        this.setState({ key: "info" })
      } else if (driverDocuments) {
        this.setState({ key: "images" })
      }
    }
  }

  render() {
    const { data } = this.state;
    const ValidationSchema = Yup.object().shape({
      gender: Yup.string().trim().nullable().required('جنسیت'),
      userType: Yup.string().trim().nullable().required('نوع کاربر'),
      firstName: Yup.string().trim().nullable().required('نام'),
      lastName: Yup.string().trim().nullable().required('نام خانوادگی'),
      // mobile: Yup.string().nullable().matches(/^[0-9]\d{10}$/, { message: "تلفن همراه باید شامل 11 رقم باشد", excludeEmptyString: false })
      //   .trim().required('وارد کردن [تلفن همراه] الزامی است'),

      mobile: Yup
        .string()
        .when("isReseller", {
          is: false,
          then: Yup.string().nullable().matches(/^[0-9]\d{10}$/, { message: "تلفن همراه باید شامل 11 رقم باشد", excludeEmptyString: false })
            .trim().required('وارد کردن [تلفن همراه] الزامی است'),
        }),

      changePass: Yup.bool(),
      password: Yup
        .string()
        .when("changePass", {
          is: true,
          then: Yup.string()
            .min(4, 'طول کلمه عبور حداقل باید 4 کاراکتر باشد')
            .trim().required('وارد کردن کلمه عبور الزامی است'),
        }),

      // changePass: Yup.bool(),
      confirmPassword: Yup
        .string()
        .when("changePass", {
          is: true,
          then: Yup.string()
            .oneOf([Yup.ref('password')], 'تکرار کلمه عبور صحیح نیست')
            .trim().required('تکرار کلمه عبور الزامی است'),
        }),

    });
    return (
      <Formik
        enableReinitialize
        initialValues={data}
        onSubmit={(values, { setSubmitting }) => {
          setSubmitting(true);
          this.handleSubmit(values, setSubmitting);
        }}
        validationSchema={ValidationSchema}
      >
        {props => {
          const {
            values,
            touched,
            errors,
            setFieldValue,
            setFieldTouched,
            isSubmitting,
            handleChange,
            handleBlur,
            handleSubmit,
            validateForm,
          } = props;
          return (
            <div>
              <div className="row" style={{ position: "relative" }}>
                <form onSubmit={handleSubmit}>
                  <button type="submit" className={"icon button submit-btn " + (isSubmitting ? "isSubmitting" : "")} disabled={isSubmitting}
                    onClick={() =>
                      validateForm().then(errors => {
                        // // console.log(errors)
                      })
                    } >
                    {isSubmitting ?
                      <AiOutlineLoading className="mdi-spin" size="22px" />
                      :
                      <AiOutlineSave size="22px" />

                    }
                    ذخیره
                  </button>
                  <Tabs transition={false}
                    id="controlled-tab-example"
                    activeKey={this.state.key}
                    onSelect={key => this.setState({ key })}
                  >

                    <Tab eventKey="info" title="اطلاعات کاربر">

                      <Step1 {...props} />

                    </Tab>
                    {/* {values && values.id && [3, 4].includes(values.userType) &&
                      <Tab eventKey="userMessages" title="پیام های کاربر">
                        <UserMessages userId={values.id} />
                      </Tab>
                    } */}

                  </Tabs>
                </form>
              </div>
              {this.state.loading ? <Loading /> : ''}
            </div>
          );
        }}
      </Formik>
    );
  }
}

export default Form;
